import { ROUTE_API } from "constant";
import {
  IBaseDataOutputModel,
  IForgotPasswordInputModel,
  IForgotPasswordOutputModel,
  ILoginInputModel,
  ILoginOutputModel,
  IProfileAuthOutputModel,
  IResetPasswordInputModel,
  IResetPasswordOutModel,
  IVerifyRefreshTokenOutputModel,
} from "interfaces";
import apiV3 from "utils/api.v3";

export const AuthServices = {
  login,
  forgotPassword,
  resetPassword,
  profile,

  verifyRefreshToken,
  refreshAccessToken,
};

function verifyRefreshToken(refreshToken: string) {
  return apiV3.post<IBaseDataOutputModel<IVerifyRefreshTokenOutputModel>>({
    url: ROUTE_API.AUTH_ROUTE.VERIFY_REFRESH_TOKEN,
    data: {
      refreshToken,
    },
  });
}

function refreshAccessToken(refreshToken: string) {
  return apiV3.post<IBaseDataOutputModel<ILoginOutputModel>>({
    url: ROUTE_API.AUTH_ROUTE.REFRESH_ACCESS_TOKEN,
    data: {
      refreshToken: refreshToken,
    },
  });
}

function login(data: ILoginInputModel) {
  return apiV3.post<IBaseDataOutputModel<ILoginOutputModel>>({ url: ROUTE_API.AUTH_ROUTE.LOGIN, data });
}

function forgotPassword(data: IForgotPasswordInputModel) {
  return apiV3.post<IBaseDataOutputModel<IForgotPasswordOutputModel>>({
    url: ROUTE_API.AUTH_ROUTE.FORGOT_PASSWORD,
    data,
  });
}

function resetPassword(data: IResetPasswordInputModel) {
  return apiV3.post<IBaseDataOutputModel<IResetPasswordOutModel>>({ url: ROUTE_API.AUTH_ROUTE.CHANGE_PASSWORD, data });
}

function profile() {
  return apiV3.get<IBaseDataOutputModel<IProfileAuthOutputModel>>({ url: ROUTE_API.AUTH_ROUTE.ME });
}
